import _ from 'underscore';

import {
  WayfinderHotspotType,
  WayfinderHotspotVariantHelper,
  WayfinderLinkType,
} from '@biteinc/enums';

app.WayfinderHotspotView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} alert-rules-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {};
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        let title;
        const fields = fieldGroupView.getValue();

        if (fields.position) {
          title = `(Position: [${fields.position.x}, ${fields.position.y}])`;
        }

        if (!fields.type) {
          return title;
        }

        if (fields.type === WayfinderHotspotType.NonInteractive) {
          if (fields.variant) {
            title = `${WayfinderHotspotVariantHelper.name(fields.variant)} ${title}`;
          }

          return title;
        }

        if (fields.type === WayfinderHotspotType.Interactive) {
          if (fields.link?.targetId) {
            if (fields.link.type === WayfinderLinkType.Section) {
              const section = app.menuSectionList.get(fields.link.targetId);
              if (section) {
                title = `Section: ${section.get('name')} ${title}`;
              } else {
                title = `Unkown Section ${fields.link.targetId} ${title}`;
              }
            } else if (fields.link.type === WayfinderLinkType.Page) {
              const pageNamesById = app.menuStructureList.models?.reduce(
                (pageNamesById, structure) => {
                  structure.attributes.pages?.forEach((page) => {
                    pageNamesById[page._id] = page.name ?? page._id;

                    page.pages?.forEach((subPage) => {
                      pageNamesById[subPage._id] = subPage.name ?? subPage._id;
                    });
                  });
                  return pageNamesById;
                },
                {},
              );
              const pageName = pageNamesById[fields.link.targetId];
              if (pageName) {
                title = `Page: ${pageName} ${title}`;
              } else {
                title = `Unkown Page ${fields.link.targetId} ${title}`;
              }
            } else if (fields.link.type === WayfinderLinkType.Item) {
              const item = app.menuItemList.get(fields.link.targetId);
              if (item) {
                title = `Item: ${item.get('posName') || item.get('name')} ${title}`;
              } else {
                title = `Unkown Item ${fields.link.targetId} ${title}`;
              }
            } else if (fields.link.type === WayfinderLinkType.None) {
              title = `No Link - ${title}`;
            }
          }

          return title;
        }

        return title || '';
      },
      templateData: {
        title: 'Hotspots',
        buttonText: 'new hotspot',
        emptyText: 'no hotspots yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
